import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { FC } from "react";
import StatCard from "../../../components/expertMode/StatCard";
import { formatSpeed } from "../../../helper/formatSpeeds";
import { formatPingTime } from "../../../helper/unitsFormatting";
import { useAppSelector } from "../../../hooks";
import { ExpertModeTheme } from "../../../theme/expert-mode";
import imagePlaceholderGraph from "./temporary-placeholder-graph-small.svg"

const Root = styled.div(
    css`
        display: flex;
        justify-content: space-between;
        gap: 24px;
        padding-right: 40%;
    `)

const Img = styled.img(
    css`
        width: 100%;
    `)

const Failure = styled.div(
    css``)

type Props = {
    expertTheme: ExpertModeTheme
}

const StatisticTab: FC<Props> = ({ expertTheme }) => {
    const state = useAppSelector(state => state.history);

    const latestRecord = state.records[state.records.length - 1];

    if (!latestRecord) return (
        <Failure>
            Es sind keine Messungen vorhanden
        </Failure>
    )

    const speedDown = formatSpeed([latestRecord.uploadFinal.speed]);
    const speedUp = formatSpeed([latestRecord.downloadFinal.speed])
    const ping = formatPingTime(latestRecord.pingFinal.pingTime);

    return (
        <Root>
            <StatCard<"step1" | "step2" | "step3"> {...{ expertTheme }}
                title="Download"
                mainValue={`${speedDown.values[0] || ""} (${speedDown.unit})`}
                chart={<Img src={imagePlaceholderGraph.src} />}
                steps={[
                    { id: "step1", label: "1. Stufe" },
                    { id: "step2", label: "2. Stufe" },
                    { id: "step3", label: "3. Stufe" },
                ]}
                selectedStep="step1"
                onSelectStep={() => { }}
                details={[
                    { label: "Bytes received", value: "TBD", trend: "up" },
                    { label: "Duration (ms)", value: "TBD", trend: "down" },
                    { label: "Out-of-order packets received", value: "TBD", trend: "up" },
                    { label: "Duplicate packets received", value: "TBD", trend: "up" },
                    { label: "RTT Avg (TCP Round Trip Time Average)", value: "TBD", trend: "down" },
                    { label: "RTT Avg (TCP Round Trip Time Average)", value: "TBD", trend: "up" },
                ]}
            />
            <StatCard<"step1" | "step2" | "step3"> {...{ expertTheme }}
                title="Upload"
                mainValue={`${speedDown.values[0] || ""} (${speedUp.unit})`}
                chart={<Img src={imagePlaceholderGraph.src} />}
                steps={[
                    { id: "step1", label: "1. Stufe" },
                    { id: "step2", label: "2. Stufe" },
                    { id: "step3", label: "3. Stufe" },
                ]}
                selectedStep="step1"
                onSelectStep={() => { }}
                details={[
                    { label: "Bytes received", value: "TBD" },
                    { label: "Duration (ms)", value: "TBD" },
                    { label: "Out-of-order packets received", value: "TBD" },
                    { label: "Duplicate packets received", value: "TBD" },
                    { label: "RTT Avg (TCP Round Trip Time Average)", value: "TBD" },
                    { label: "RTT Avg (TCP Round Trip Time Average)", value: "TBD" },
                ]}
            />
            <StatCard<"step1"> {...{ expertTheme }}
                title="Ping"
                mainValue={`${ping} (ms)`}
                chart={<Img src={imagePlaceholderGraph.src} />}
                steps={[
                    { id: "step1", label: "1. Stufe" }
                ]}
                selectedStep="step1"
                onSelectStep={() => { }}
                details={[
                    { label: "Bytes received", value: "TBD" },
                    { label: "Duration (ms)", value: "TBD" },
                    { label: "Out-of-order packets received", value: "TBD" },
                    { label: "Duplicate packets received", value: "TBD" },
                    { label: "RTT Avg (TCP Round Trip Time Average)", value: "TBD" },
                    { label: "RTT Avg (TCP Round Trip Time Average)", value: "TBD" },
                ]}
            />
        </Root>
    )
}

export default StatisticTab